var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34589",
    "data-name": "Path 34589",
    d: "M1.744,0H32.256A1.752,1.752,0,0,1,34,1.76V20.24A1.752,1.752,0,0,1,32.256,22H1.744A1.752,1.752,0,0,1,0,20.24V1.76A1.752,1.752,0,0,1,1.744,0Z",
    fill: "#0e4595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34590",
    "data-name": "Path 34590",
    d: "M123.874,157.823l1.447-8.677h2.314l-1.448,8.677Zm10.675-8.49a5.863,5.863,0,0,0-2.074-.364c-2.287,0-3.9,1.177-3.911,2.864-.013,1.247,1.15,1.943,2.028,2.358.9.425,1.2.7,1.2,1.076-.006.582-.719.847-1.385.847a4.763,4.763,0,0,1-2.179-.456l-.3-.138-.325,1.943a7.188,7.188,0,0,0,2.578.463c2.433,0,4.012-1.163,4.03-2.965.009-.987-.608-1.738-1.943-2.358-.809-.4-1.3-.669-1.3-1.076,0-.361.419-.746,1.325-.746a4.191,4.191,0,0,1,1.732.332l.207.1.314-1.881m5.956-.187h-1.788a1.148,1.148,0,0,0-1.212.72l-3.437,7.952h2.43s.4-1.069.487-1.3l2.964,0c.069.3.281,1.3.281,1.3h2.148l-1.873-8.672Zm-2.837,5.6c.191-.5.922-2.426.922-2.426-.014.023.19-.5.307-.828l.156.748s.443,2.071.536,2.506Zm-15.758-5.6-2.266,5.918-.241-1.2a6.725,6.725,0,0,0-3.205-3.64l2.072,7.589,2.449,0,3.644-8.661H121.91",
    transform: "translate(-111.046 -142.446)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34591",
    "data-name": "Path 34591",
    d: "M64.042,152.956H60.228l-.03.181a7.829,7.829,0,0,1,5.746,4.54l-.829-3.988a.99.99,0,0,0-1.072-.733",
    transform: "translate(-57.53 -146.239)",
    fill: "#f2ae14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaplan);
export default __webpack_public_path__ + "static/media/visaplan.48e5f9daccda8d65d8c4193bb6af7da5.svg";
export { ForwardRef as ReactComponent };